import { FormikProps } from 'formik';
import React from 'react';
import { AddressField } from '../../../../../global/components/form-element/address';
import { DividerSection } from '../../../../../global/components/layout/divider-section';
import { LabelSettingProps } from '../../../../../global/models/epi-model';
import { BasicInfo } from '../../../../account-info/features/personal-info/basic-info';
import { EmailInfo } from '../../../../account-info/features/personal-info/email-info';
import { PhoneInfo } from '../../../../account-info/features/personal-info/phone-info';
import { MailingAddressFieldNames } from '../../../../account-info/models/form-models';
import { getAddressLabels } from '../../../../account-info/selectors/form-selectors';
import { PerformPersonSearchContext } from '../../person-search/person-search-model';
import { GetNewHireAddressRequiredSchema } from '../models/new-hire-model';

interface Props {
    formProps: FormikProps<any>;
    labelSetting: LabelSettingProps;
}
export function NewHirePersonalInfoFields(props: Props) {
    const { formProps, labelSetting } = props;

    return (
        <PerformPersonSearchContext.Provider value>
            <DividerSection>
                <BasicInfo
                    labelSetting={labelSetting}
                    formikProps={formProps}                    
                />
            </DividerSection>
            <DividerSection sectionText={labelSetting.mailingAddressTitle} >

                <AddressField
                    currentCountry={formProps.values.mailing_country === '' ? 'US' : formProps.values.mailing_country}
                    labels={getAddressLabels(labelSetting)}
                    addressFieldNames={MailingAddressFieldNames}
                    requiredSchema={GetNewHireAddressRequiredSchema(true, formProps.values.mailing_country)}
                    formProps={formProps}
                    person
                />
            </ DividerSection>

            <PhoneInfo
                labelSetting={labelSetting}
                formProps={formProps}
            />
            <EmailInfo
                labelSetting={labelSetting}
                formProps={formProps}
                hideDescription
                removeDivider
            />
        </PerformPersonSearchContext.Provider>
    );
}